<template>
    <el-row class="warp">
        <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
            <!--工具条-->
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
                <el-form :inline="true" ref="filters" :model="filters">
                    <el-form-item label="选择品牌" prop="brandid">
                        <el-select v-model.trim="filters.brandid" clearable filterable placeholder="请选择品牌(可搜索)">
                            <el-option v-for="item in BrandList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search()">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="add()">增加</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="resetForm('filters')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table :data="pros" highlight-current-row v-loading="loading" border style="width: 100%">
                <el-table-column label="序号" type="index" :index="indexMethod"></el-table-column>
                <el-table-column label="轮播图" prop="imgurl" min-width="80">
                    <template slot-scope="scope">
                        <div class="demo-image__preview">
                            <el-image style="width: 60px; height: 40px" :src="scope.row.imgurl">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="所属品牌" prop="brandid">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.brandid === 1 ? 'primary' : 'success'" disable-transitions>
                            {{ scope.row.brandid == 1 ? '孚日' : '洁玉' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="商品链接ID" prop="detaillink"></el-table-column>
                <el-table-column label="更新时间" prop="updatetime" width="180" :formatter="formatTime"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="edit(scope.$index, scope.row)">修改</el-button>
                        <el-button type="text" @click="del(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-col :span="24" class="toolbar">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                    :page-sizes="[10, 20, 50]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </el-col>
            <!-- 修改页面 -->
            <el-dialog title="编辑" :visible.sync="editFormVisible" center :close-on-click-modal="false"
                @close="resetForm('editForm')">
                <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm" class="demo-ruleForm">
                    <el-form-item label="所属品牌" prop="brandid">
                        <el-select v-model.trim="editForm.brandid" clearable filterable placeholder="请选择(可搜索)">
                            <el-option v-for="item in BrandList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-row :gutter="10">
                        <el-col :span="10">
                            <!-- <el-form-item label="链接ID" prop="detaillink">
                                    <el-input v-model="editForm.detaillink" placeholder="请在活动专题页查看ID"></el-input>
                                </el-form-item> -->
                            <el-form-item label="链接专题" prop="detaillink">
                                <el-select v-model.trim="editForm.detaillink" clearable filterable placeholder="请选择专题页">
                                    <el-option v-for="item in promotionList" :key="item.id"
                                        :label="'ID:' + item.id + '*' + '时间:' + dateFormat(item.updatetime, 'yyyy-MM-dd HH:mm:ss')"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="缩略图" prop="imgurl">
                        <el-upload class="avatar-uploader" action="/mallapi/MallApi/file/upload" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                            <img v-if="editForm.imgurl" :src="editForm.imgurl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div class="el-upload__tip" slot="tip" style="font-weight: bold">图片只能是 JPG
                                格式，且不超过2M
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="editFormVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="submit" :loading="addLoading">提交</el-button>
                </div>
            </el-dialog>
        </el-col>
</el-row>
</template>
<script>

import MallApi from "../../../api/goods/carouselapi"
import ProApi from "../../../api/goods/promotionapi"
import moment from 'moment'
export default {
    data() {
        return {
            filters: {
                brandid: ""
            },
            BrandList: [{ id: 1, name: "孚日" }, { id: 2, name: "洁玉" }],
            promotionList: [],//专题页列表

            loading: false,
            total: 0,
            page: 1,
            limit: 10,
            pros: [],

            editFormVisible: false,
            editForm: {
                brandid: '',
                imgurl: '',
                detaillink: ''
            },
            editFormRules: {
                brandid: [{ required: true, message: "请选择品牌", trigger: "change" }],
                imgurl: [{ required: true, message: "请上传轮播图片", trigger: "blur" }],
               // detaillink: [{ required: true, message: "请选择专题页ID", trigger: "change" }],
            },
            dialogVisible: false,
            //提交按钮状态
            addLoading: false,
        };

    },
    methods: {
        indexMethod(index) {
            return (index + 1) + (this.page - 1) * (this.limit)
        },
        //时间格式转化
        dateFormat(dateData) {
            var date = new Date(dateData);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            var H = date.getHours();
            H = H < 10 ? "0" + H : H;
            var ms = date.getMinutes()
            ms = ms < 10 ? "0" + ms : ms;
            var s = date.getMilliseconds()
            s = s < 10 ? "0" + s : s;
            const time = y + "-" + m + "-" + d + " " + H + ":" + ms + ":" + s;
            return time;
        },
        formatTime(row, column) {
            let date = row[column.property];
            if (date === undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        handleCurrentChange(val) {
            this.page = val;
            this.search();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.search();
        },
        handleSearch() {
            this.total = 0;
            this.page = 1;
            this.search();
        },
        search: function () {
            let params = {
                pageNum: this.page,
                pageSize: this.limit,
                brandid: this.filters.brandid,
            };

            this.loading = true

            let that = this
            MallApi.list(params)
                .then(
                    function (result) {
                        that.loading = false;
                        if (result && result.data.totalSize) {
                            that.total = result.data.totalSize;
                            that.pros = result.data.content;
                        } else {
                            that.total = 0;
                            that.pros = null;
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000,
                        });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000,
                    });
                });
        },


        resetForm(formName) {
            this.$refs['editForm'].resetFields();
        },

        //页面
        add: function (index, row) {
            this.editFormVisible = true;
            this.handlePro()
        },
        edit: function (index, row) {
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row)
            this.handlePro()
        },
        //保存
        submit: function () {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let that = this;
                    this.addLoading = true;
                    MallApi.save(this.editForm).then(function (result) {
                        if (0 === result.code) {
                            that.addLoading = false;
                            that.$message;
                            that.$message.success({
                                showClose: true,
                                message: "操作成功",
                                duration: 2000,
                            });
                            that.$refs["editForm"].resetFields();
                            that.editFormVisible = false;
                            that.search();
                        } else {
                            that.$message.error({

                                showClose: true,
                                message: result.message || "操作失败",
                                duration: 2000,
                            });
                            that.addLoading = false;
                        }
                    });
                }
            })
        },

        del(e) {
            let that = this;
            this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
                .then(() => {
                    that.loading = true;
                    MallApi.delete({ id: e.id })
                        .then(
                            function (result) {
                                that.loading = false;
                                if (result && parseInt(result.code) === 0) {
                                    that.$message.success({
                                        showClose: true,
                                        message: "删除成功",
                                        duration: 1500,
                                    });
                                    that.search();
                                } else {
                                    that.$message.error({
                                        showClose: true,
                                        message: result.message,
                                        duration: 1500,
                                    });
                                }
                            },
                            function (err) {
                                that.loading = false;
                                that.$message.error({
                                    showClose: true,
                                    message: err.toString(),
                                    duration: 2000,
                                });
                            }
                        )
                        .catch(function (error) {
                            that.loading = false;
                            console.log(error);
                            that.$message.error({
                                showClose: true,
                                message: "请求出现异常",
                                duration: 2000,
                            });
                        });
                })
                .catch(() => { });
        },


        //缩略图上传
        handleAvatarSuccess(res) {
            if (res.code === 0) {
                this.editForm.imgurl = "data:image/jpeg;base64," + res.data
                this.$forceUpdate() //强制渲染
            } else {
                this.$message.error(res.message)
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        //加载专题页列表
        handlePro() {
            let that = this;
            ProApi.listpros().then(function (result) {
                if (0 === result.code) {
                    that.promotionList = result.data;
                } else {
                    that.$message.error({
                        showClose: true,
                        message: result.msg || "操作失败",
                        duration: 2000,
                    });
                }
            });
        },
    },

    mounted() {
        this.handleSearch()
    },
};
</script>

<style scoped></style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
